module YVR.Utilities.Events {
	// Constants
	export const DEBOUNCE_INTERNVAL = 250;

	/**
	 * Throttle, adapted from underscore.js
	 * @param func
	 * @param wait
	 * @param options
	 */
	export function throttle(func: Function, wait: number, options = { leading: null, trailing: null }) {
		let _this;
		let args;
		let result;

		let timeout = null;
		let previous = 0;

		const later = () => {
			previous = options.leading === false ? 0 : Date.now();
			timeout = null;
			result = func.apply(_this, args);

			if (!timeout) {
				_this = args = null;
			}
		};

		return function () {
			const now = Date.now();

			if (!previous && options.leading === false) {
				previous = now;
			}

			const remaining = wait - (now - previous);

			_this = this;
			args = arguments;

			if (remaining <= 0 || remaining > wait) {
				if (timeout) {
					clearTimeout(timeout);
					timeout = null;
				}

				previous = now;
				result = func.apply(_this, args);

				if (!timeout) {
					_this = args = null;
				}

			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining);
			}

			return result;
		};
	}


	/**
	 * Debounce, adapted from underscore.js
	 */
	export function debounce(func: Function, wait: number, immediate = false) {
		let timeout;
		let args;
		let context;
		let timestamp;
		let result;

		const later = () => {
			const last = Date.now() - timestamp;

			if (last < wait && last >= 0) {
				timeout = setTimeout(later, wait - last);
			} else {
				timeout = null;

				if (!immediate) {
					result = func.apply(context, args);

					if (!timeout) {
						context = args = null;
					}
				}
			}
		};

		return function () {
			context = this;
			args = arguments;
			timestamp = Date.now();

			const callNow = immediate && !timeout;

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}

			if (callNow) {
				result = func.apply(context, args);
				context = args = null;
			}

			return result;
		};
	}


	// Set up for pageYOffset
	const supportPageOffset = window.pageXOffset !== undefined;
	const isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');

	/**
	 * PageYOffset cross-browser function. Adapted from:
	 * https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
	 * @return {integer} The page Y offset.
	 */
	export function pageYOffset(): number {
		return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
	}
}
